import { AxiosInstance } from "axios";
import { ApiRoutes } from "../../../root/apiRoutes";
import { UserDetailsDto } from "../dto/UserDto";
import { parsePhoneNumber } from "libphonenumber-js";

// On the backend this isn't a standard Controller, so it cannot be automatically generated.
export class LoginController {
  constructor(private axios: AxiosInstance) {}

  public login(username: string, password: string): Promise<UserDetailsDto> {
    const url = ApiRoutes.user.login;
    const transformRequest = (jsonData = {}) =>
      Object.keys(jsonData)
        .map((x) => `${encodeURIComponent(x)}=${encodeURIComponent(jsonData[x])}`)
        .join("&");
    const config = {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      transformRequest,
    };
    const body = { username, password };

    return this.axios.post<UserDetailsDto>(url, body, config).then((response) => response.data);
  }

  public logout(): Promise<any> {
    return this.axios.get(ApiRoutes.user.logout);
  }

  public resetPassword(email: string): Promise<void> {
    const url = ApiRoutes.user.forgotPassword;
    const params = {
      headers: { "Content-Type": "text/plain" },
    };

    return this.axios.post(url, email, params).then((response) => response.data);
  }

  public createMfaChallenge(token: string, phone: string): Promise<void> {
    const url = ApiRoutes.mfa.root;
    const params = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.axios
      .post(
        url,
        {
          token,
          phone: parsePhoneNumber(phone, "US")?.number,
        },
        params,
      )
      .then((response) => response.data);
  }

  public validateMfaCode(data: { token: string; code: string; phone?: string }): Promise<void> {
    const url = ApiRoutes.mfa.validate;
    const params = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.axios.post(url, data, params).then((response) => response.data);
  }
}
